import DownloadIcon from '@mui/icons-material/Download';
import { Fade, IconButton, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { MenuOption } from 'shared/types';

interface ExportIconDropdownMenuProps {
    title: string;
    disabled?: boolean;
    menuOptions: MenuOption[];
}

export function ExportIconDropdownMenu({ title, disabled, menuOptions }: ExportIconDropdownMenuProps) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <>
            <IconButton
                id='export-dropdown-button'
                color='primary'
                aria-label={`${title}`}
                title={`${title}`}
                onClick={handleClick}
                aria-expanded={open ? 'true' : undefined}
                aria-controls={open ? 'dropdown-menu' : undefined}
                aria-haspopup='true'
            >
                <DownloadIcon />
            </IconButton>
            <Menu
                id='export-dropdown-menu'
                MenuListProps={{
                    'aria-labelledby': 'export-dropdown-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                TransitionComponent={Fade}
            >
                {menuOptions.map((option, i) => (
                    <MenuItem
                        key={i}
                        disabled={option.disabled}
                        onClick={() => {
                            handleClose();
                            option.action(option.key);
                        }}
                    >
                        {option.value}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
}
